import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7e1ba154")

_pushScopeId("data-v-7e1ba154")
const _hoisted_1 = { class: "card-content" }
const _hoisted_2 = {
  key: 0,
  class: "card-group"
}
const _hoisted_3 = {
  key: 0,
  class: "card-group-label"
}
const _hoisted_4 = { class: "display-flex" }
const _hoisted_5 = { class: "flex1" }
const _hoisted_6 = { class: "flex1 label-text-right" }
const _hoisted_7 = /*#__PURE__*/_createVNode("span", { class: "margin-left8px" }, "$", -1)
const _hoisted_8 = { class: "card-group-items" }
const _hoisted_9 = { class: "card-title" }
const _hoisted_10 = { class: "card-content" }
const _hoisted_11 = {
  key: 1,
  class: "card-group"
}
const _hoisted_12 = { class: "card-group-label" }
const _hoisted_13 = { class: "display-flex" }
const _hoisted_14 = { class: "flex1" }
const _hoisted_15 = { class: "flex1 label-text-right" }
const _hoisted_16 = /*#__PURE__*/_createVNode("span", { class: "margin-left8px" }, "$", -1)
const _hoisted_17 = { class: "card-group-items" }
const _hoisted_18 = { class: "card-title" }
const _hoisted_19 = { class: "card-content" }
const _hoisted_20 = {
  key: 2,
  class: "card-group"
}
const _hoisted_21 = { class: "card-group-label" }
const _hoisted_22 = { class: "display-flex" }
const _hoisted_23 = { class: "flex1" }
const _hoisted_24 = { class: "flex1 label-text-right" }
const _hoisted_25 = /*#__PURE__*/_createVNode("span", { class: "margin-left8px" }, "$", -1)
const _hoisted_26 = { class: "card-group-items" }
const _hoisted_27 = { class: "card-title" }
const _hoisted_28 = { class: "card-content" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_detail_dialog = _resolveComponent("detail-dialog")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.orderData.main.length>0)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          (_ctx.projectType!=='23')
            ? (_openBlock(), _createBlock("div", _hoisted_3, [
                _createVNode("div", _hoisted_4, [
                  _createVNode("div", _hoisted_5, _toDisplayString(_ctx.$wordList.RDeviceSearchLabelRoomName), 1),
                  _createVNode("div", _hoisted_6, [
                    _createVNode("span", null, _toDisplayString(_ctx.$wordList.Price), 1),
                    _hoisted_7,
                    _createVNode("span", null, _toDisplayString(_ctx.mainPrice), 1)
                  ])
                ]),
                _createVNode("div", _hoisted_8, _toDisplayString(_ctx.orderData.main.length) + " " + _toDisplayString(_ctx.$wordList.Items), 1)
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.orderData.main, (main) => {
            return (_openBlock(), _createBlock("div", {
              class: "card-main blue",
              key: main.ID
            }, [
              _createVNode("div", _hoisted_9, _toDisplayString(main.Object), 1),
              _createVNode("div", _hoisted_10, [
                _createTextVNode("$ " + _toDisplayString(main.Price) + " ", 1),
                (['8','10'].includes(main.Type) && main.Days!=='0')
                  ? (_openBlock(), _createBlock("div", {
                      key: 0,
                      class: "card-more",
                      onClick: ($event: any) => (_ctx.more(main))
                    }, _toDisplayString(_ctx.$wordList.ProperAllTextMore), 9, ["onClick"]))
                  : _createCommentVNode("", true)
              ])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (_ctx.orderData.sub.length>0)
      ? (_openBlock(), _createBlock("div", _hoisted_11, [
          _createVNode("div", _hoisted_12, [
            _createVNode("div", _hoisted_13, [
              _createVNode("div", _hoisted_14, _toDisplayString(_ctx.$wordList.AdditionalApp), 1),
              _createVNode("div", _hoisted_15, [
                _createTextVNode(_toDisplayString(_ctx.$wordList.Price) + " ", 1),
                _hoisted_16,
                _createVNode("span", null, _toDisplayString(_ctx.subPrice), 1)
              ])
            ]),
            _createVNode("div", _hoisted_17, _toDisplayString(_ctx.orderData.sub.length) + " " + _toDisplayString(_ctx.$wordList.Items), 1)
          ]),
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.orderData.sub, (sub) => {
            return (_openBlock(), _createBlock("div", {
              class: "card-main blue",
              key: sub.ID
            }, [
              _createVNode("div", _hoisted_18, _toDisplayString(sub.Object), 1),
              _createVNode("div", _hoisted_19, [
                _createTextVNode("$ " + _toDisplayString(sub.Price) + " ", 1),
                (['8','10'].includes(sub.Type))
                  ? (_openBlock(), _createBlock("div", {
                      key: 0,
                      class: "card-more",
                      onClick: ($event: any) => (_ctx.more(sub))
                    }, _toDisplayString(_ctx.$wordList.ProperAllTextMore), 9, ["onClick"]))
                  : _createCommentVNode("", true)
              ])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (_ctx.orderData.pmApp.length>0)
      ? (_openBlock(), _createBlock("div", _hoisted_20, [
          _createVNode("div", _hoisted_21, [
            _createVNode("div", _hoisted_22, [
              _createVNode("div", _hoisted_23, _toDisplayString(_ctx.$wordList.PmApp), 1),
              _createVNode("div", _hoisted_24, [
                _createTextVNode(_toDisplayString(_ctx.$wordList.Price) + " ", 1),
                _hoisted_25,
                _createVNode("span", null, _toDisplayString(_ctx.pmPrice), 1)
              ])
            ]),
            _createVNode("div", _hoisted_26, _toDisplayString(_ctx.orderData.pmApp.length) + " " + _toDisplayString(_ctx.$wordList.Items), 1)
          ]),
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.orderData.pmApp, (pmApp) => {
            return (_openBlock(), _createBlock("div", {
              class: "card-main blue",
              key: pmApp.ID
            }, [
              _createVNode("div", _hoisted_27, _toDisplayString(pmApp.Object), 1),
              _createVNode("div", _hoisted_28, [
                _createTextVNode("$ " + _toDisplayString(pmApp.Price) + " ", 1),
                (['8','10'].includes(pmApp.Type) && pmApp.Days!=='0')
                  ? (_openBlock(), _createBlock("div", {
                      key: 0,
                      class: "card-more",
                      onClick: ($event: any) => (_ctx.more(pmApp))
                    }, _toDisplayString(_ctx.$wordList.ProperAllTextMore), 9, ["onClick"]))
                  : _createCommentVNode("", true)
              ])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (_ctx.isShowMoreDialog)
      ? (_openBlock(), _createBlock(_component_detail_dialog, {
          key: 3,
          onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isShowMoreDialog = false)),
          data: _ctx.moreData
        }, null, 8, ["data"]))
      : _createCommentVNode("", true)
  ]))
})